import AnimatedFail from './AnimatedFail.jsx'

export default AnimatedFail
